import { RFX_TABS } from "utils/constants";

export type RfxTab = (typeof RFX_TABS)[keyof typeof RFX_TABS];

export enum RfxTabNumbers {
	RFxDetails = 1,
	Documentation = 2,
	ReturnableSchedule = 3,
	Quote = 4,
	RfxParticipants = 5,
}

export interface RfxTabTotals {
	addendums: number;
	comms: number;
	documentation: number;
	quote: number;
	returnableSchedule: number;
}

export type FileUploadFile = {
	downloadUrl: string;
	file_size: number;
	name: string;
	path: string;
	type: string;
};

export enum TextLength {
	SHORT = "Short",
	LONG = "Long",
	L4500 = "4500",
}
